import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { Injectable } from "@nestjs/common";
import { RequestDto } from "./dto/request.dto";
import { RequestForm } from "./entity/request.entity";


@Injectable()
export class RequestFormAdapter{
    public convertDtoToEntity(requestFormDTO: RequestDto): RequestForm{
        const requestFormEntity = new RequestForm();
        requestFormEntity.requestId= requestFormDTO.requestId;
        requestFormEntity.visitType= requestFormDTO.visitType;
        requestFormEntity.employeeName= requestFormDTO.employeeName;
        requestFormEntity.employeeCode= requestFormDTO.employeeCode;
        requestFormEntity.department= requestFormDTO.department;
        requestFormEntity.visitorName= requestFormDTO.visitorName.join(',');
        requestFormEntity.visitorCard= requestFormDTO.visitorCard;
        requestFormEntity.visitorEmail= requestFormDTO.visitorEmail;
        requestFormEntity.visitorMobileNumber= requestFormDTO.visitorMobileNumber;
        requestFormEntity.aadharNumber= requestFormDTO.aadharNumber;
        requestFormEntity.visitorAddress= requestFormDTO.visitorAddress;
        requestFormEntity.visitorArrivalDate= requestFormDTO.visitorArrivalDate; 
        requestFormEntity.visitorDepartureDate= requestFormDTO.visitorDepartureDate;
        requestFormEntity.purposeOfVisit= requestFormDTO.purposeOfVisit;
        requestFormEntity.whomMeet= requestFormDTO.whomMeet;
        requestFormEntity.transportation= requestFormDTO.transportation;
        requestFormEntity.vehicleNumber= requestFormDTO.vehicleNumber;
        requestFormEntity.driverName= requestFormDTO.driverName;
        requestFormEntity.statusByHod= LeaveApprovalStatusEnum.OPEN;
        requestFormEntity.statusByHr= LeaveApprovalStatusEnum.OPEN;
        requestFormEntity.rejectionReason= requestFormDTO.rejectionReason;
        requestFormEntity.vaccination= requestFormDTO.vaccination;
        requestFormEntity.isActive= requestFormDTO.isActive === undefined ? true : requestFormDTO.isActive;
        return requestFormEntity;
    }

    public convertEntityToDto(requestFormObj: RequestForm): RequestDto{
        console.log(requestFormObj);
        const requestFormDTO = new RequestDto;
        requestFormDTO.requestId= requestFormObj.requestId;
        requestFormDTO.visitType= requestFormObj.visitType;
        requestFormDTO.employeeName= requestFormObj.employeeName;
        requestFormDTO.employeeCode= requestFormObj.employeeCode;
        requestFormDTO.department= requestFormObj.department;
        requestFormDTO.visitorName= requestFormObj.visitorName.split(",");
        requestFormDTO.visitorCard= requestFormObj.visitorCard;
        requestFormDTO.visitorEmail= requestFormObj.visitorEmail;
        requestFormDTO.visitorMobileNumber= requestFormObj.visitorMobileNumber;
        requestFormDTO.aadharNumber= requestFormObj.aadharNumber;
        requestFormDTO.visitorAddress= requestFormObj.visitorAddress;
        requestFormDTO.visitorArrivalDate= requestFormObj.visitorArrivalDate;
        requestFormDTO.visitorDepartureDate= requestFormObj.visitorDepartureDate;
        requestFormDTO.transportation= requestFormObj.transportation;
        requestFormDTO.vehicleNumber= requestFormObj.vehicleNumber;
        requestFormDTO.driverName= requestFormObj.driverName;
        requestFormDTO.statusByHod = requestFormObj.statusByHod;
        requestFormDTO.statusByHr = requestFormObj.statusByHr;
        requestFormDTO.rejectionReason= requestFormObj.rejectionReason;
        requestFormDTO.purposeOfVisit= requestFormObj.purposeOfVisit;
        requestFormDTO.whomMeet= requestFormObj.whomMeet;
        requestFormDTO.vaccination = requestFormObj.vaccination;
        return requestFormDTO;
    }

    public convertUpdateDtoToEntity(requestFormDTO: RequestDto): RequestForm{
        const requestFormEntity = new RequestForm();
        requestFormEntity.requestId= requestFormDTO.requestId;
        requestFormEntity.visitType= requestFormDTO.visitType;
        requestFormEntity.employeeName= requestFormDTO.employeeName;
        requestFormEntity.employeeCode= requestFormDTO.employeeCode;
        requestFormEntity.department= requestFormDTO.department;
        // requestFormEntity.visitorName= requestFormDTO.visitorName;
        requestFormEntity.visitorCard= requestFormDTO.visitorCard;
        requestFormEntity.visitorEmail= requestFormDTO.visitorEmail;
        requestFormEntity.visitorMobileNumber= requestFormDTO.visitorMobileNumber;
        requestFormEntity.aadharNumber= requestFormDTO.aadharNumber;
        requestFormEntity.visitorAddress= requestFormDTO.visitorAddress;
        requestFormEntity.visitorArrivalDate= requestFormDTO.visitorArrivalDate; 
        requestFormEntity.visitorDepartureDate= requestFormDTO.visitorDepartureDate;
        requestFormEntity.purposeOfVisit= requestFormDTO.purposeOfVisit;
        requestFormEntity.whomMeet= requestFormDTO.whomMeet;
        requestFormEntity.transportation= requestFormDTO.transportation;
        requestFormEntity.vehicleNumber= requestFormDTO.vehicleNumber;
        requestFormEntity.driverName= requestFormDTO.driverName;
        requestFormEntity.rejectionReason= requestFormDTO.rejectionReason;
        requestFormEntity.vaccination= requestFormDTO.vaccination;
        requestFormEntity.isActive= requestFormDTO.isActive === undefined ? true : requestFormDTO.isActive;
        return requestFormEntity;
    }
}